import { memoize } from 'lodash'

import { ADDITIONAL_DATA_KEY, MAIN_DATA_KEY } from 'modules/Monitoring/consts/chart'
import { ChartData } from 'modules/Monitoring/types'

type DataField = typeof MAIN_DATA_KEY | typeof ADDITIONAL_DATA_KEY

type Extractor = (data?: ChartData[0]) => number | undefined

function makeExtractor(field: DataField, value: string): Extractor {
  return (data?: ChartData[0]) => data?.[field]?.[value]?.value
}

// Recharts remounts a series' curve and dots whenever its `dataKey` changes identity,
// so the same extractor must be returned for the same field and value.
export const makeSafeDataKeyExtractor = memoize(
  (field: DataField, value: string) => makeExtractor(field, value),
  (field, value) => `${field}:${value}`,
)
